import styled from 'styled-components'
import Icon from '@ant-design/icons'

export const IconStyled = styled(Icon)`
	svg{
			width: 100%;
			height: 100%;
	}
`